import React from 'react';
// eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
import { graphql, useFragment } from 'react-relay';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazy } from '@atlassian/react-loosely-lazy';
import type { async_softwareReleasesAddRelatedWorkToVersion_AddRelatedWorkPopup_jiraVersion$key } from './__generated__/async_softwareReleasesAddRelatedWorkToVersion_AddRelatedWorkPopup_jiraVersion.graphql';
import type { async_softwareReleasesAddRelatedWorkToVersion_AddRelatedWorkPopup_relatedWorkEdges$key } from './__generated__/async_softwareReleasesAddRelatedWorkToVersion_AddRelatedWorkPopup_relatedWorkEdges.graphql';
import type { RenderTrigger } from './index.tsx';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const LazyAddRelatedWorkPopup = lazy(() =>
	import(/* webpackChunkName: "async-add-related-work-popup" */ './index').then(
		(module) => module.AddRelatedWorkPopup,
	),
);

type Props = {
	jiraVersion: async_softwareReleasesAddRelatedWorkToVersion_AddRelatedWorkPopup_jiraVersion$key;
	renderTrigger: RenderTrigger;
	relatedWorkEdges: async_softwareReleasesAddRelatedWorkToVersion_AddRelatedWorkPopup_relatedWorkEdges$key;
};

export const AddRelatedWorkPopup = ({
	jiraVersion,
	renderTrigger,
	relatedWorkEdges,
}: Props): React.JSX.Element => {
	const version = useFragment(
		// eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
		graphql`
			fragment async_softwareReleasesAddRelatedWorkToVersion_AddRelatedWorkPopup_jiraVersion on JiraVersion {
				...addRelatedWorkPopup_softwareReleasesAddRelatedWorkToVersion_jiraVersion
			}
		`,
		jiraVersion,
	);

	const edges = useFragment(
		// eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
		graphql`
			fragment async_softwareReleasesAddRelatedWorkToVersion_AddRelatedWorkPopup_relatedWorkEdges on JiraVersionRelatedWorkV2Edge
			@relay(plural: true) {
				...addRelatedWorkPopup_softwareReleasesAddRelatedWorkToVersion_relatedWorkEdges
			}
		`,
		relatedWorkEdges,
	);

	return (
		<Placeholder
			name="add-related-work-popup"
			fallback={renderTrigger({
				triggerProps: {},
				onClick: () => undefined,
				onMouseOver: () => undefined,
				isLoading: true,
			})}
		>
			<LazyAddRelatedWorkPopup
				jiraVersion={version}
				renderTrigger={renderTrigger}
				relatedWorkEdges={edges}
			/>
		</Placeholder>
	);
};
